export default __webpack_public_path__ + "static/media/fun_portal_rick_and_morty.573dd4b7.jpg";